import { render, staticRenderFns } from "./ReleasePayments.vue?vue&type=template&id=f0a763f2&scoped=true"
import script from "./ReleasePayments.vue?vue&type=script&lang=js"
export * from "./ReleasePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a763f2",
  null
  
)

export default component.exports